import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

/*
 * Area de login
 */
import Login from "@/views/auth/Login.vue";
//import ResetPassword from "@/views/auth/ResetPassword.vue";
//import EmailConfirmation from "@/views/auth/EmailConfirmation.vue";
import Register from "@/views/auth/Register.vue";

Vue.use(VueRouter);

const routes = [
	/* Auth */
	{
		path: "/auth/login",
		component: Login,
	},
	{
		path: "/auth/register",
		component: Register,
	},
	// {
	// 	path: "/auth/reset-password",
	// 	name: "AuthResetPassword",
	// 	component: ResetPassword,
	// },
	// {
	// 	path: "/auth/email-confirmation/:token?",
	// 	name: "EmailConfirmation",
	// 	component: EmailConfirmation,
	// },
	/* Auth */

	{
		path: "/",
		name: "home",
		component: HomeView,
	},

	{
		path: "/cdi",
		name: "CdiFormView",
		component: () =>
			import(/* webpackChunkName: "cdi" */ "@/views/cdi/Form.vue"),
	},

	{
		path: "/cdi/votacion",
		name: "CdiVotacionView",
		component: () =>
			import(/* webpackChunkName: "cdi" */ "@/views/cdi/Votacion.vue"),
	},

	{
		path: "/cdi/folio/:folio",
		name: "CdiFolioView",
		component: () =>
			import(/* webpackChunkName: "cdi" */ "@/views/cdi/Dibujo.vue"),
	},

	{
		path: "/cdi/votacion/:region?/:age1?/:age2?/:age3?/:page?",
		name: "CdiVotacionCategoriesView",
		component: () =>
			import(/* webpackChunkName: "votacion" */ "@/views/cdi/Categories.vue"),
	},

	{
		path: "/literatura",
		name: "LiteratureFormView",
		component: () =>
			import(
				/* webpackChunkName: "literature" */ "@/views/literature/Form.vue"
			),
	},

	{
		path: "/jornada-de-artistas",
		name: "ArtistFormView",
		component: () =>
			import(
				/* webpackChunkName: "jornada-artistas" */ "@/views/artistas/Form.vue"
			),
	},

	{
		path: "/altares",
		name: "altares",
		component: function () {
			return import(
				/* webpackChunkName: "altares" */ "../views/altares/Index.vue"
			);
		},
	},

	{
		path: "/altares/rme/folio/:uuid",
		name: "altaresUuidRme",
		component: function () {
			return import(
				/* webpackChunkName: "altares" */ "../views/altares/FolioUuidRme.vue"
			);
		},
	},

	{
		path: "/altares/rme/:page?",
		name: "altaresRme",
		component: function () {
			return import(
				/* webpackChunkName: "altares" */ "../views/altares/Rme.vue"
			);
		},
	},

	{
		path: "/altares/comunidades/folio/:uuid",
		name: "altaresUuidComunidades",
		component: function () {
			return import(
				/* webpackChunkName: "altares" */ "../views/altares/FolioUuid.vue"
			);
		},
	},

	{
		path: "/altares/comunidades/:page?",
		name: "altaresComunidades",
		component: function () {
			return import(
				/* webpackChunkName: "altares" */ "../views/altares/Comunidades.vue"
			);
		},
	},

	{
		path: "/votable",
		name: "votable",
		component: function () {
			return import(
				/* webpackChunkName: "votable" */ "../views/votable/test.vue"
			);
		},
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
